import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import React from 'react';
import { useController } from 'react-hook-form';

// TODO: Typa
const ControlledMultiCheckBox = (props) => {
  const { items, value, label, name, disabled = false } = props; // required & disabled propsas in men används ingenstans

  const { field } = useController({
    name,
  });

  // let isError = false;
  // let errorMessage = '';
  // if (errors && Object.prototype.hasOwnProperty.call(errors, name)) {
  //   isError = true;
  //   errorMessage = errors[name].message;
  // }

  const [internalValue, setInternalValue] = React.useState(value || []); // KOmmentar

  return (
    <Box sx={{ mt: -1.5 }}>
      <Typography variant='caption' gutterBottom sx={{ lineHeight: 1, color: 'rgba(0, 0, 0, 0.6)' }}>
        {label}
      </Typography>
      <Box>
        {items.map((c, index) => (
          <FormControlLabel
            key={c.value}
            sx={{
              alignItems: 'flex-start',
              '& .MuiCheckbox-root': {
                pt: 0,
              },
              '&.Mui-disabled': {
                color: (thm) => `${thm.palette.text.disabled} !important`,
                cursor: 'not-allowed',
              },
            }}
            name={name}
            disableTypography
            control={
              <Checkbox
                onChange={(e) => {
                  const valueCopy = [...internalValue];

                  // update checkbox value
                  valueCopy[index] = e.target.checked ? e.target.value : null;

                  // send data to react hook form
                  field.onChange(valueCopy);

                  // ConsoleHelper.log('valueCopy', valueCopy, name);
                  // setValue(name.replace('.value', '.formValue'), valueCopy);

                  // update local state
                  setInternalValue(valueCopy);
                }}
                checked={internalValue.includes(c.value) || false}
                value={c.value}
                disabled={disabled}
              />
            }
            label={<span>{c.label}</span>}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ControlledMultiCheckBox;
